<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useNavStore } from '@/stores/nav.store'
import ItextChallengeNSolution from '@/components/casestudy/itext/ItextChallengeNSolution.vue'
import ItextDemoCTA from '@/components/casestudy/itext/ItextDemoCTA.vue'
import ItextImageBanner from '@/components/casestudy/itext/ItextImageBanner.vue'
import ItextLogoandDesc from '@/components/casestudy/itext/ItextLogoandDesc.vue'

import MobileAppSection from '@/components/shared/MobileAppSection.vue'

const navStore = useNavStore()

onMounted(() => {
  navStore.setIsMarketingPage(true)
})

onUnmounted(() => {
  navStore.setIsMarketingPage(false)
})
</script>

<template>
  <ItextImageBanner />
  <ItextLogoandDesc />
  <ItextChallengeNSolution />
  <ItextDemoCTA />
  <MobileAppSection />
</template>
